import http from '@/utils/http'

const fetchAll = () => http()
  .get(`/experts`)

const fetch = ({ id }) => http()
  .get(`/experts/${id}`)

const updatePriorities = ({ priorities }) => http()
  .post(`/expert_priorities`, { priorities: JSON.stringify(priorities) })

const save = ({ id, data }) => http()
  .put(`/experts/${id}`, data)

const remove = ({ id }) => http()
  .delete(`/experts/${id}`)

const invite = ({ email, password, password_confirmation }) => http()
  .post(`/experts`, { email, password, password_confirmation })

const availabilities = () => http()
  .get('/availabilities')

export default {
  fetchAll,
  fetch,
  updatePriorities,
  save,
  remove,
  invite,
  availabilities
}



// WEBPACK FOOTER //
// ./src/api/expert.js